/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/reviews/desktop.app.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/reviews/desktop.app', exports: {} };
const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import mopReviews from '@take-2/fd-modules/movie/shared/desktop/mopReviews';



import ratingsTabs from '@take-2/fd-modules/movie/shared/desktop/movieRatingsTabs';



import verifiedAudienceReview from '@take-2/fd-modules/movie/shared/desktop/verifiedAudienceReview';

function run() {
    checkDependencies(module.name, debugLog);
    mopReviews.init();
    ratingsTabs.init();
    verifiedAudienceReview.init();
}
run();
export default {  };